import React, { useState } from 'react';
import { Layout, Menu, Button, message } from 'antd';
import styles from './index.module.scss'
import {
  HomeOutlined,
  UserOutlined,
  VideoCameraOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  SettingOutlined,
  UsergroupAddOutlined,
  SoundOutlined,
  ContactsOutlined
} from '@ant-design/icons';
import NavBar from '../components/NavBar';
import type { MenuProps } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import { getTemplateCount } from '../../api/clone';
import { AxiosResponse, AxiosError } from 'axios';
import { meshBounds } from '@react-three/drei';
import { useTranslation } from 'react-i18next';

const { Sider, Content } = Layout;

const CollapsibleSidebar = () => {
  const [collapsed, setCollapsed] = useState<boolean>(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const currentPath = location.pathname;
  type MenuItem = Required<MenuProps>['items'][number];
  const menuItems: MenuItem[] = [
    { key: '/console/home', icon: <HomeOutlined />, label: t('console.home') },
    {
      key: '/console/clone', icon: <UsergroupAddOutlined />, label: t('console.digital_human'), children: [
        { key: '/console/clone/template', label: t('console.video_template') },
        { key: '/console/clone/videoCreate', label: t('console.video_creation') },

      ]
    },
    { key: '/console/video', icon: <VideoCameraOutlined />, label: t('console.my_video') },
    { key: '/console/voice', icon: <SoundOutlined />, label: t('console.my_voice') },
    /*{ key: '/console/employee', icon: <ContactsOutlined />, label: t('console.digital_employee'), children: [
      { key: '/console/employee/productmgr', label: '产品经理' },
      { key: '/console/employee/lawyer', label: '律师' },
      { key: '/console/employee/teacher', label: '外语老师' },
      { key: '/console/employee/engineer', label: '工程师' }
    ]},*/
    
    { key: '/console/account', icon: <SettingOutlined />, label: t('console.setting') },
    
  ];

  const getSelectedKeys = () => {

    // 检查是否是子菜单项的路径
    if (currentPath.includes('/console/clone/templateCreate')) {
      return ['/console/clone/template'];
    }

    // 检查是否是顶级菜单路径
    return [currentPath];
  };

  const toggleCollapsed = () => {
    setCollapsed(!collapsed);
  };

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    navigate(e.key);
  };

  const handleCreateVideo = () => {
    getTemplateCount({}).then((res: AxiosResponse) => {
      if (res.data.status === 200) {
        console.log(res.data.data)
        if (res.data.data.count > 0) {
          navigate('/console/clone/videoCreate')
          message.success("已发现模板，跳转到创建视频")
        } else {
          navigate('/console/clone/template')
          message.success("未发现模板，跳转到创建模板")

        }
        
      }
    })
  }


  return (
    <Layout className={styles.layout}>
      <NavBar />
      <Layout>
        <Sider
          className={styles.sidebar}
          collapsible
          collapsed={collapsed}
          trigger={null}
          width={200}
        >
          <div className={styles.sidebarHeader}>
            {!collapsed && (
              <Button className={styles.createVideoButton} onClick={handleCreateVideo}>
                {t('console.create_video')}
              </Button>
            )}
            <Button
              type="text"
              onClick={toggleCollapsed}
              className={styles.toggleButton}
            >
              {collapsed ? <MenuFoldOutlined /> : <MenuUnfoldOutlined />}
            </Button>
          </div>

          <Menu
            mode="inline"
            onClick={handleMenuClick}
            items={menuItems}
            className={styles.menu}
            theme="light"
            selectedKeys={getSelectedKeys()}

          />
        </Sider>
        <Layout className={styles.siteLayout}>
          <Content className={styles.siteLayoutBackground}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default CollapsibleSidebar;